import React from "react";
import { Box } from "@chakra-ui/react";

export function ContentIcon() {
  return (
    <Box as="svg" xmlns="http://www.w3.org/2000/svg" boxSize="icon.xl" viewBox="0 0 32 32" fill="none">
      <Box
        as="path"
        fill="new.blue.900"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9961 4C26.2052 4 27.9961 5.79086 27.9961 8V24C27.9961 26.2091 26.2052 28 23.9961 28H7.99609C5.78728 27.9996 3.99609 26.2089 3.99609 24V21.3333C3.99609 20.5972 4.59338 20.0004 5.32943 20C6.06581 20 6.66276 20.597 6.66276 21.3333V24C6.66276 24.5715 7.02346 25.0577 7.52865 25.2474L10.5013 22.276C12.0088 20.7687 14.4203 20.7164 15.9909 22.1185L17.2747 20.8346C18.7722 19.3372 21.1788 19.2678 22.7617 20.6745L25.3294 22.957V8C25.3294 7.26362 24.7325 6.66667 23.9961 6.66667H7.99609C7.26004 6.66705 6.66276 7.26386 6.66276 8V10.6667C6.66276 11.403 6.06581 12 5.32943 12C4.59338 11.9996 3.99609 11.4028 3.99609 10.6667V8C3.99609 5.7911 5.78728 4.00039 7.99609 4H23.9961ZM14.2721 24.1615C13.7515 23.6414 12.9072 23.6411 12.3867 24.1615L11.2148 25.3333H15.444L14.2721 24.1615ZM20.9896 22.6667C20.4619 22.1982 19.6605 22.2223 19.1615 22.7214L17.8815 24L19.2148 25.3333H23.9896L20.9896 22.6667Z"
      />
      <Box
        as="path"
        fill="new.blue.900"
        d="M10.069 11.3411C10.5213 10.4353 11.8887 10.4443 11.832 11.3529L11.7422 12.793C11.676 13.8581 12.349 14.6806 13.4323 14.8581L16.6628 15.1107C17.9961 15.1107 17.9961 16.8893 16.6628 16.8893L12.8516 17.1758C11.6817 17.3479 10.9345 18.155 10.4089 19.2083L9.6849 20.6589C9.23552 21.558 7.87956 21.5581 7.92188 20.6589L7.99609 19.112C8.04414 18.1069 7.06028 17.3211 6.05859 17.1042L4.51042 16.7695C3.61657 16.5753 3.96618 15.2947 4.96615 15.1003L6.69792 14.7656C7.81811 14.5487 8.86181 13.7627 9.36328 12.7578L10.069 11.3411Z"
      />
      <Box
        as="path"
        fill="new.blue.900"
        d="M22.6641 14.6667C23.4002 14.667 23.9974 15.2638 23.9974 16C23.9974 16.7362 23.4002 17.333 22.6641 17.3333H21.3307C20.5944 17.3333 19.9974 16.7364 19.9974 16C19.9974 15.2636 20.5944 14.6667 21.3307 14.6667H22.6641Z"
      />
      <Box
        as="path"
        fill="new.blue.900"
        d="M22.6641 9.33333C23.4002 9.33364 23.9974 9.93048 23.9974 10.6667C23.9974 11.4029 23.4002 11.9997 22.6641 12H15.9974C15.261 12 14.6641 11.403 14.6641 10.6667C14.6641 9.93029 15.261 9.33333 15.9974 9.33333H22.6641Z"
      />
    </Box>
  );
}
